import { render, staticRenderFns } from "./MediaSection.vue?vue&type=template&id=530bf7ff&scoped=true&"
import script from "./MediaSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MediaSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MediaSection.vue?vue&type=style&index=0&id=530bf7ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bf7ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530bf7ff')) {
      api.createRecord('530bf7ff', component.options)
    } else {
      api.reload('530bf7ff', component.options)
    }
    module.hot.accept("./MediaSection.vue?vue&type=template&id=530bf7ff&scoped=true&", function () {
      api.rerender('530bf7ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/MediaSection.vue"
export default component.exports